import { render, staticRenderFns } from "./DocumentDetailEform.vue?vue&type=template&id=b78e12b0&scoped=true"
import script from "./DocumentDetailEform.vue?vue&type=script&lang=js"
export * from "./DocumentDetailEform.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailEform.vue?vue&type=style&index=0&id=b78e12b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78e12b0",
  null
  
)

export default component.exports